import React from "react";
import { extractFileNameUrl } from "../../../utils/url";
import { ThumbnailWrapper } from "../style";

const renderThumbnailPreview = (src, alt, title) => (
    <>
        <img
            className="thumbnail__image"
            src={src}
            alt={alt}
        />
        <small className="eui-textTruncate">{title}</small>
    </>
);

function Thumbnail({ url = "", alt, title, src }) {
    const thumbnailTitle = title || extractFileNameUrl(url);
    const thumbnailPreview = renderThumbnailPreview(src, alt, thumbnailTitle);

    return (
        <ThumbnailWrapper>
            {src ? (
                url ? (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={url}
                        title={thumbnailTitle}
                        className="eui-textCenter thumbnail__container"
                    >
                        {thumbnailPreview}
                    </a>
                ) : (
                    <div className="thumbnail__container">{thumbnailPreview}</div>
                )
            ) : (
                <small>No image found</small>
            )}
        </ThumbnailWrapper>
    );
}

export default Thumbnail;
